import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const API = process.env.REACT_APP_API_URL || '';


export default function SettingsPage() {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    // Check if user is authenticated
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    // Verify token is valid
    axios.get(`${API}/api/me`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      setLoading(false);
    }).catch((err) => {
      if (err.response?.status === 401 || err.response?.status === 403) {
        navigate("/login", { replace: true });
      } else {
        setLoading(false);
      }
    });
  }, [token, navigate]);

  if (loading) {
    return (
      <div className="settings-page">
        <div className="loading-indicator">Loading...</div>
      </div>
    );
  }

  async function updateName() {
    try {
      await axios.put(`${API}/api/user/update-name`, 
        { name },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage("Name updated!");
    } catch (err) {
      setMessage(err.response?.data?.error || "Error updating name");
    }
  }

  async function updatePassword() {
    try {
      await axios.put(`${API}/api/user/update-password`, 
        { password },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage("Password updated!");
    } catch (err) {
      setMessage(err.response?.data?.error || "Error updating password");
    }
  }

  const getMessageClass = () => {
    if (!message) return "";
    if (message.includes("updated") || message.includes("success")) return "success";
    if (message.includes("Error") || message.includes("error")) return "error";
    return "";
  };

  return (
    <div className="settings-page">
      <h2>Account Settings</h2>

      <div className="settings-section">
        <h3>Change Username</h3>
        <div className="settings-form">
          <div className="settings-input-group">
            <label htmlFor="username">New Username</label>
            <input
              id="username"
              className="settings-input"
              type="text"
              placeholder="Enter new username"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <button className="settings-button" onClick={updateName} disabled={!name.trim()}>
            Update Username
          </button>
        </div>
      </div>

      <div className="settings-section">
        <h3>Change Password</h3>
        <div className="settings-form">
          <div className="settings-input-group">
            <label htmlFor="password">New Password</label>
            <input
              id="password"
              className="settings-input"
              type="password"
              placeholder="Enter new password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button className="settings-button" onClick={updatePassword} disabled={!password.trim()}>
            Update Password
          </button>
        </div>
      </div>

      {message && (
        <div className={`settings-message ${getMessageClass()}`}>
          {message}
        </div>
      )}
    </div>
  );
}
